import { fontSize } from "../chatFontSize";
import styled from "styled-components";

import { chatColors, monitorColors } from "../chatColors";

export type StyledNameIconProps = {
  color?: string;
};

export const StyledNameIcon = styled.div`
  min-width: 28px;
  height: 28px;
  line-height: 28px;
  font-size: ${fontSize.r_SMALL};
  border-radius: 50%;
  text-align: center;
  color: ${chatColors.white};
  background: ${(str: StyledNameIconProps) =>
    str.color || monitorColors.sakura};
`;
